import { makeStyles } from "@material-ui/core"

import { colors } from "@/styles/colors"
import { themeColors } from "letalkui"
import ColorUtil from "@/utils/ColorUtil"

const useStyles = makeStyles({
	deleteSnoozeButton: {
		...ColorUtil.getBackgroundAndContrastColor(colors.red[400]),
		"&:hover": {
			opacity: 0.8,
			...ColorUtil.getBackgroundAndContrastColor(colors.red[400])
		}
	},
	previewMessageContent: {
		width: "100%",
		maxHeight: 500,
		padding: 16,
		overflowY: "auto",
		borderRadius: 8,
		"&::-webkit-scrollbar": {
			width: "0.25em"
		},
		"&::-webkit-scrollbar-track": {
			...ColorUtil.getBackgroundAndContrastColor(colors.gray[300]),
			borderRadius: "0px 8px 8px 8px"
		},
		"&::-webkit-scrollbar-thumb": {
			...ColorUtil.getBackgroundAndContrastColor(colors.gray[400]),
			borderRadius: 8,
			border: "2px solid transparent"
		}
	},
	messagePreview: {
		borderRadius: 4
	},
	container: {
		alignItems: "flex-end"
	},
	button: {
		background: themeColors.colors.error[500],
		height: "40px",
		padding: "0px 8px",
		fontSize: "14px",
		"&:hover": {
			...ColorUtil.getBackgroundAndContrastColor(themeColors.colors.error[600])
		}
	}
})

export default useStyles
